import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';
import { useTranslation } from 'react-i18next';

const LogoutConfirmationModal = ({ isOpen, onCloseClick, onLogoutClick, isLoading = false }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalBody>
        {/* text-dark, not text-primary. These were written when $primary was #122335 — a
            near-black navy — so `text-primary` LOOKED like dark text and was used as such.
            Once the brand colour became themeable they started rendering crimson/teal/purple,
            which reads as an error state on a routine confirmation. The confirm button below
            carries the only colour that should be here, and it is semantic (danger), not brand. */}
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.Power size={60} className="text-dark" />
          <div className="fs-4 pt-2 text-dark">{t('areYouSure')}</div>
          <div className="fs-6 pt-2">{t('logoutMessage')}</div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        {/* Cancel stays neutral too: on the Crimson preset an accent-coloured Cancel would sit
            next to the red Logout button as two near-identical reds. */}
        <Button onClick={onCloseClick} className="px-5 bg-transparent text-dark">
          {t('cancel')}
        </Button>
        <Button
          onClick={onLogoutClick}
          className="d-flex justify-content-center align-items-center gap-2 px-5 bg-danger border-danger">
          {t('logout')}
          {isLoading ? <Spinner size="sm" color="light" /> : null}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

LogoutConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onLogoutClick: PropTypes.func
};

export default LogoutConfirmationModal;
